import { useNavigate } from "react-router-dom";

import Button from "../../../ui/Button";
import style from "./RedefineSignUp.module.scss";
import { useAppSelector } from "../../../store/hooks";

/**
 * The sign-up call to action.
 *
 * Whether someone is signed in comes from the store, not from a
 * `sessionStorage.userStatus` key the Firebase flow used to write and nothing
 * writes any more.
 */
export function RedefineSignUp() {
  const navigate = useNavigate();
  const isAuth = useAppSelector((state) => Boolean(state.auth.accessToken));

  return (
    <div className={style.RedefineSignUp}>
      <div className="wrapper-constrain">
        <h2>Re-define the way you journey.</h2>
        <p>
          Say hello to shared adventures, lifelong connections, and a fresh
          perspective on the road ahead.
        </p>

        <Button
          onClick={() => {
            void navigate(isAuth ? "/dashboard/rider/overview" : "/sign-up");
          }}
          variant="primary"
          content={isAuth ? "Book a ride" : "Sign Up"}
        />
      </div>
    </div>
  );
}
